import { SwitchTransition, CSSTransition } from "react-transition-group";
import { useState, useEffect } from "react";

import styles from "./Animation.module.css";

export const SwitchAnimation = ({ children, keyAnimation }) => {
  return (
    <SwitchTransition>
      <CSSTransition
        key={keyAnimation}
        classNames={{
          enter: styles.enter,
          enterActive: styles.enterActive,
          exit: styles.exit,
          exitActive: styles.exitActive,
        }}
        timeout={400}
      >
        <div>{children}</div>
      </CSSTransition>
    </SwitchTransition>
  );
};

export const RenderAnimation = ({ children }) => {
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    setDisplay(true);
  }, []);

  return (
    <CSSTransition
      in={display}
      classNames={{
        enter: styles.enter,
        enterActive: styles.enterActive,
        exit: styles.exit,
        exitActive: styles.exitActive,
      }}
      timeout={400}
    >
      <div>{children}</div>
    </CSSTransition>
  );
};
